//@flow
import React from "react"
import fetch from "isomorphic-fetch"
import styled from "styled-components"

const SVGContainer = styled.div`
  height: ${props => props.height};
  width: ${props => props.width};

  & > svg {
    height: 100%;
    width: 100%;

    path,
    polygon {
      fill: ${props => props.fill || "auto"};
    }
  }
`

type Props = {
  path: string,
  height: string,
  width: string,
  fill?: string,
  style?: Object
}

type State = {
  svgData: ?string
}

class SVGLoader extends React.Component<Props, State> {
  static cache: Map<string, string> = new Map()

  constructor(props: Props) {
    super(props)
    this.state = { svgData: null }
  }

  componentWillMount = () => {
    this.setSVGData()
  }

  componentDidUpdate = (prevProps: Props) => {
    if (prevProps.path !== this.props.path) {
      this.setSVGData()
    }
  }

  setSVGData = async () => {
    const { path } = this.props
    if (path) {
      var svgData = "" //SVGLoader.cache.get(path)
      if (svgData === "") {
        try {
          const response = await fetch(path)
          svgData = await response.text()
          SVGLoader.cache.set(path, svgData)
        } catch (err) {
          console.log(err)
        }
      }
      this.setState(() => ({ svgData }))
    }
  }

  render() {
    const { height, width, fill, style } = this.props
    const { svgData } = this.state
    return (
      <SVGContainer
        height={height}
        width={width}
        fill={fill}
        dangerouslySetInnerHTML={{ __html: svgData || "" }}
        style={style || {}}
      />
    )
  }
}

export default SVGLoader



// WEBPACK FOOTER //
// ./src/UI/SVGLoader/index.js